import { useNavigate } from "react-router-dom";
import { Brand } from "~/components/brand/Brand";
import { Icon } from "~/components/base/Icon";
import { useT } from "~/hooks/useT";
import { useUiStore } from "~/stores/uiStore";
import { useCartStore } from "~/stores/cartStore";

export function AppMobileTopbar() {
  const navigate = useNavigate();
  const { t } = useT();
  const toggleDrawer = useUiStore((s) => s.toggleDrawer);
  const cartCount = useCartStore((s) => s.count());

  return (
    <div className="mobile-topbar">
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <button
          type="button"
          className="btn btn--ghost btn--sm"
          onClick={toggleDrawer}
          aria-label={t("menu")}
          style={{ padding: 6, height: 32, width: 32 }}
        >
          <Icon name="list" size={18} />
        </button>
        <button
          type="button"
          onClick={() => navigate("/dashboard")}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            background: "transparent",
            border: "none",
            padding: 0,
            cursor: "pointer",
          }}
          aria-label={t("dashboard")}
        >
          <Brand height={12} withMark showChip />
        </button>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <button
          type="button"
          className="btn btn--ghost btn--sm"
          aria-label={t("notifications")}
          style={{ padding: 6, height: 32, width: 32 }}
        >
          <Icon name="bell" size={17} />
        </button>
        <button
          type="button"
          className="btn btn--ghost btn--sm"
          onClick={() => navigate("/cart")}
          aria-label={t("cart")}
          style={{
            padding: 6,
            height: 32,
            width: 32,
            position: "relative",
          }}
        >
          <Icon name="cart" size={17} />
          {cartCount > 0 && (
            <span
              style={{
                position: "absolute",
                top: 2,
                right: 2,
                background: "var(--blue)",
                color: "#fff",
                fontFamily: "var(--font-mono)",
                fontSize: 9,
                fontWeight: 600,
                minWidth: 14,
                height: 14,
                padding: "0 3px",
                borderRadius: 999,
                display: "grid",
                placeItems: "center",
              }}
            >
              {cartCount}
            </span>
          )}
        </button>
      </div>
    </div>
  );
}
